import React from 'react';
import PropTypes from 'prop-types';

// @atlaskit
import Button from '@atlaskit/button';
import Tooltip from '@atlaskit/tooltip';

// @source
import { RouteLink } from '../../../../components';

const OperationButton = ({ tooltip, href, Icon }) => (
  <Tooltip content={tooltip} position="left">
    <Button
      appearance="subtle"
      component={RouteLink}
      href={`/users/${href}`}
      iconBefore={<Icon size="small" />}
    />
  </Tooltip>
);

OperationButton.propTypes = {
  tooltip: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  Icon: PropTypes.node.isRequired,
};

export default OperationButton;
